import A from "./ruoli-a.json";
import B from "./ruoli-b.json";
import C from "./ruoli-c.json";
import EXTRA from "./ruoli-extra.json";
import SETTORI_RAW from "./settori.json";
import GA from "./guide-a.json";
import GB from "./guide-b.json";
import HUBS_RAW from "./hubs.json";
import GEXTRA from "./guide-extra.json";
import SEXTRA from "./settori-extra.json";

const merge = (X) => (r) => ({ ...r, sections: [...r.sections.slice(0, -1), ...(X[r.slug] || []), r.sections[r.sections.length - 1]] });
const withExtra = merge(EXTRA);

export const RUOLI = [...A, ...B, ...C].map(withExtra);
export const SETTORI = SETTORI_RAW.map(merge(SEXTRA));
export const GUIDE = [...GA, ...GB].map(merge(GEXTRA));
export const HUBS = HUBS_RAW;
export const BY = {
  ruoli: Object.fromEntries(RUOLI.map((x) => [x.slug, x])),
  settori: Object.fromEntries(SETTORI.map((x) => [x.slug, x])),
  guide: Object.fromEntries(GUIDE.map((x) => [x.slug, x])),
};
export const ROLE_LINKS = {
  "operai e addetti produzione": "operai-produzione", magazzinieri: "magazzinieri", autisti: "autisti", "tecnici e manutentori": "tecnici-manutentori",
  estetiste: "estetiste", "personale sala e cucina": "personale-sala-cucina", "addetti vendita": "addetti-vendita", "commerciali e agenti": "commerciali-agenti",
  receptionist: "receptionist", "impiegati amministrativi": "impiegati-amministrativi", "capi reparto": "capi-reparto", "team leader": "capi-reparto",
  "manager e direttori": "manager-direttori", "area manager": "manager-direttori", contabili: "impiegati-amministrativi", "back office": "impiegati-amministrativi",
  "key account": "commerciali-agenti", "inside sales": "commerciali-agenti", coordinatori: "capi-reparto",
};
